import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { SurveyFormValues } from "pages/SurveyCreate/SurveyForm";
import { BaseApiPaging } from "./types";
import { Question } from "survey";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = ""
): AxiosPromise<BaseApiPaging<SurveyApi>> => {
  return api.get<BaseApiPaging<SurveyApi>>(endpoints.SURVEYS.GET(skip, take, searchPhrase, filter, orderBy));
};

const fetchById = (id: number): AxiosPromise<SurveyApi> => {
  return api.get<SurveyApi>(endpoints.SURVEYS.GET_BY_ID(id));
};

const create = (data: SurveyFormValues): AxiosPromise<number> => {
  return api.post<number>(endpoints.SURVEYS.CREATE(), data);
};

const deleteSurvey = (id: number): Promise<void> => {
  return api.delete(endpoints.SURVEYS.DELETE(id));
};

const update = (id: number, data: SurveyFormValues): AxiosPromise<void> => {
  return api.put<void>(endpoints.SURVEYS.UPDATE(id), data);
};

const updateQuestion = async (surveyId: number, questionId: number, data: Question): AxiosPromise<void> => {
  return api.put<void>(endpoints.SURVEYS.UPDATE_QUESTION(surveyId, questionId), data);
};

const createQuestion = async (surveyId: number, data: Question): AxiosPromise<number> => {
  return api.post<number>(endpoints.SURVEYS.CREATE_QUESTION(surveyId), data);
};

const deleteQuestion = async (surveyId: number, questionId: number): AxiosPromise<void> => {
  return api.delete<void>(endpoints.SURVEYS.DELETE_QUESTION(surveyId, questionId));
};

/** Saves the whole order at once: the editor calls it right after a question is moved. */
const reorderQuestions = async (surveyId: number, questionIds: number[]): AxiosPromise<void> => {
  return api.put<void>(endpoints.SURVEYS.REORDER_QUESTIONS(surveyId), { questionIds });
};

export const surveyApi = {
  fetch,
  fetchById,
  create,
  delete: deleteSurvey,
  update,
  updateQuestion,
  createQuestion,
  deleteQuestion,
  reorderQuestions,
};

interface UpdateFormApi {
  name: string;
  description: string;
  questions: {
    question: string;
    description?: string;
    placeholder?: string;
    textQuestionTypes?: string;
    questionOptionType?: string;
    lowerLabel?: string;
    upperLabel?: string;
    required?: boolean;
    options?: { id: string; value: string }[];
  }[];
}

export interface SurveyApi {
  id: number;
  name: string;
  description: string;
  isEndCourse: boolean;
  questions: SurveyQuestionApi[];
}

export interface SurveyQuestionApi {
  id: number;
  question: string;
  description: string;
  placeholder: string;
  textType: string;
  inputType: string;
  questionOptionType: string;
  lowerLabel: string;
  upperLabel: string;
  required: boolean;
  sortOrder: number;
  options: { id: string; value: string }[];
}
